module.exports = __webpack_public_path__ + "img/digitrack.9f0bfb4a.png";